import React, { useEffect, useState } from 'react';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 15 * 60);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="animate-slide-down bg-[#6b3fa0] text-white py-3 px-4 text-center font-bold text-sm md:text-base sticky top-0 z-50 shadow-lg" data-id="element-278">
      <span data-id="element-279">⏳ OFERTA EXPIRA EN: </span>
      <span className="font-mono bg-purple-900/50 px-2 py-0.5 rounded mx-1" data-id="element-280">
        {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
      </span>
      <span className="mx-2" data-id="element-281">|</span>
      <span data-id="element-282">🔥 CUPOS LIMITADOS</span>
    </div>;
}